import { useQuery } from '@tanstack/react-query';
import type { IOrganisation } from '../../interfaces';
import type { IAccount } from '../../interfaces/Account/IAccount.ts';
import { STALE_TIME_DETAIL_MS, STALE_TIME_LIST_MS } from '../../constants/reactQueryStaleTime.ts';
import AccountService from '../../services/AccountService.ts';
import OrganisationService from '../../services/OrganisationService.ts';

// React Query keys for OrganisationPage (centralized for consistency)
export const getOrganisationQueryKey = (organisationId?: string) =>
  ['organisation', organisationId] as const;

export const getOrganisationCockpitUsersQueryKey = (organisationId?: string) =>
  ['organisationCockpitUsers', organisationId] as const;

export function useOrganisationQuery(organisationId?: string) {
  return useQuery<IOrganisation>({
    queryKey: getOrganisationQueryKey(organisationId),
    enabled: !!organisationId,
    queryFn: () => OrganisationService.getOrganisation(organisationId!),
    staleTime: STALE_TIME_DETAIL_MS,
  });
}

export function useOrganisationCockpitUsersQuery(organisationId?: string) {
  return useQuery<IAccount[]>({
    queryKey: getOrganisationCockpitUsersQueryKey(organisationId),
    enabled: !!organisationId,
    staleTime: STALE_TIME_LIST_MS,
    queryFn: async () => {
      const response = await AccountService.getAccounts(
        1,
        100,
        undefined,
        undefined,
        'Organisation manager',
        undefined,
        'last_name',
        'asc',
        organisationId
      );
      return response.items ?? [];
    },
  });
}

